// Azure Entra External ID (CIAM)
// Tenant: phcmanutenzioniauth.onmicrosoft.com

const ciamTenantName = import.meta.env.VITE_CIAM_TENANT_NAME || 'phcmanutenzioniauth';
const ciamTenantId = import.meta.env.VITE_CIAM_TENANT_ID || 'f98ceced-ed97-45bc-a978-a335f65d2381';
const ciamClientId = import.meta.env.VITE_CIAM_CLIENT_ID || '84a58755-5a90-408c-9260-25e09970e55c';

// External ID usa ciamlogin.com (non b2clogin.com) e non richiede policy
const ciamAuthority = `https://${ciamTenantName}.ciamlogin.com/${ciamTenantId}`;
const ciamAuthorityDomain = `${ciamTenantName}.ciamlogin.com`;

// Export per compatibilità (non usato con CIAM)
export const b2cPolicies = null;

export const msalConfig = {
  auth: {
    clientId: ciamClientId,
    authority: ciamAuthority,
    knownAuthorities: [ciamAuthorityDomain],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true  // Migliora compatibilità con IE/Edge legacy e iframe
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0: console.error(message); break;
          case 1: console.warn(message); break;
          case 2: console.info(message); break;
          case 3: console.debug(message); break;
        }
      },
      logLevel: import.meta.env.DEV ? 3 : 1
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email']
};

export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_URL ? import.meta.env.VITE_API_URL : '/api'
};
